import { MoreUrls } from '@tallink/components-lib'

const ENV_TO_EXTERNAL_SERVICES = {
  local: {
    bookUrl: 'https://dev-redirect.fleet.zone/book/',
    serialTicketsUrl: '',
    ssoUrl: 'https://dev-sso.fleet.zone/component/sso.js',
    paymentServiceUrl: '/payment-service'
  },
  dev: {
    bookUrl: 'https://dev-redirect.fleet.zone/book/',
    serialTicketsUrl: '',
    ssoUrl: 'https://dev-sso.fleet.zone/component/sso.js',
    paymentServiceUrl: 'https://dev-payment-service-public.fleet.zone'
  },
  test: {
    bookUrl: 'https://test-redirect.fleet.zone/book/',
    serialTicketsUrl: '',
    ssoUrl: 'https://test-sso.fleet.zone/component/sso.min.js',
    paymentServiceUrl: 'https://test-payment-service-public.fleet.zone'
  },
  prod: {
    bookUrl: 'https://travel.tallink.com/book/',
    serialTicketsUrl: '',
    ssoUrl: 'https://sso.tallink.com/component/sso.min.js',
    paymentServiceUrl: 'https://payment.tallink.com'
  }
}

const ENV_TO_SUPPORTED_HOSTNAMES = {
  local: ['localhost', 'host.docker.internal'],
  dev: ['dev-serial-tickets.fleet.zone', 'ci.fleet.zone'],
  test: ['test-serial-tickets.fleet.zone'],
  prod: ['serialtickets.tallink.com']
}

export function getEnv(hostname) {
  const hostnameOrDefault = hostname || window.location.hostname
  if (isProdEnv(hostnameOrDefault)) return 'prod'
  if (isTestEnv(hostnameOrDefault)) return 'test'
  if (isDevEnv(hostnameOrDefault)) return 'dev'
  if (isLocalEnv(hostnameOrDefault)) return 'local'
  throw new Error(`Not able to initialize application because hostname ${hostname} is not supported.`)
}

export function getEnvBasedConfig(hostname) {
  const env = getEnv(hostname)
  return ENV_TO_EXTERNAL_SERVICES[env]
}

function isTestEnv(hostname) {
  return ENV_TO_SUPPORTED_HOSTNAMES.test.includes(hostname)
}

function isDevEnv(hostname) {
  return ENV_TO_SUPPORTED_HOSTNAMES.dev.includes(hostname)
}

function isLocalEnv(hostname) {
  return ENV_TO_SUPPORTED_HOSTNAMES.local.includes(hostname) || MoreUrls.isIpAddress(hostname)
}

function isProdEnv(hostname) {
  return ENV_TO_SUPPORTED_HOSTNAMES.prod.includes(hostname)
}
